import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayReverseFilter',
    pure: false,
    standalone: true
})
export class ArrayReverseFilterPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        return items.filter((item) => Object.keys(filter).some((key) => item[key] !== filter[key]));
    }
}